var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_236_1127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 15.75L15.75 4.5L13.5 2.25L2.25 13.5L4.5 15.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 4.5L13.5 6.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.25C6.75 2.64782 6.90804 3.02936 7.18934 3.31066C7.47064 3.59196 7.85218 3.75 8.25 3.75C7.85218 3.75 7.47064 3.90804 7.18934 4.18934C6.90804 4.47064 6.75 4.85218 6.75 5.25C6.75 4.85218 6.59196 4.47064 6.31066 4.18934C6.02936 3.90804 5.64782 3.75 5.25 3.75C5.64782 3.75 6.02936 3.59196 6.31066 3.31066C6.59196 3.02936 6.75 2.64782 6.75 2.25Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75C14.25 10.1478 14.408 10.5294 14.6893 10.8107C14.9706 11.092 15.3522 11.25 15.75 11.25C15.3522 11.25 14.9706 11.408 14.6893 11.6893C14.408 11.9706 14.25 12.3522 14.25 12.75C14.25 12.3522 14.092 11.9706 13.8107 11.6893C13.5294 11.408 13.1478 11.25 12.75 11.25C13.1478 11.25 13.5294 11.092 13.8107 10.8107C14.092 10.5294 14.25 10.1478 14.25 9.75Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_236_1127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiAdd);
export default __webpack_public_path__ + "static/media/ai_add.eb54b2bf73ff1a10d48087cc2313149e.svg";
export { ForwardRef as ReactComponent };